import React, { Component } from 'react';
import {
    faUserCircle,
    faPlus,
    faBullhorn,
    faHistory,
    faUsers,
    faPlane,
    faMapSigns,
    faBed,
    faBus,
    faCar,
    faPaperPlane,
    faChevronCDown,
    faChevronDown,
    faChevronRight
  } from "@fortawesome/free-solid-svg-icons";

  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class DashAnnDetail extends Component {
    render() {
        return (
            <div className="col-5 d-flex justify-content-between align-items-center">
                    <div className="ann__detail ">
                      <h6 className="ann__detail__txt mt-3 pl-5"><FontAwesomeIcon icon={faChevronRight} className="mr-2"/>Du {this.props.from} Au {this.props.to} : <b>{this.props.client}</b></h6>
    
                    </div>
                    <div className="dash__ann__actions d-flex align-items-center">
                      <img src="/imgs/dash/edit.svg" className="ann__actions__sub" alt="" />
                      {/* <img src="/imgs/dash/times.svg"className="ann__actions__sub ml-2" alt="" /> */}
                    </div>
            </div>
        );
    }
}

export default DashAnnDetail;
